/// <reference path="" />

(function ($, undefined) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        $.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Basic Contact View Model
    // Holds the Contact Data for the Person
    /**************************************/
    function BasicContactViewModel(sectionWrapper) {
        var self = this;
        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();

        /***  PROPERTIES ***/
        this.PrimaryPhoneNumberGID = ko.observable();
        this.PrimaryPhoneNumberID = ko.observable();
        this.PrimaryPhoneNumber = ko.validatedObservable();
        this.PrimaryPhoneExtension = ko.validatedObservable();
        this.PrimaryPhoneCountryPrefixCode = ko.validatedObservable();
        this.PrimaryPhoneAreaCityCode = ko.validatedObservable();

        this.PermanentMailingAddress = ko.observable(new sm.portal.vm.MailingAddressViewModel());
        this.PrimaryMailingAddress = ko.observable(new sm.portal.vm.MailingAddressViewModel());

        // add permanent basic details to subcontext
        this.SelectedCountryID = ko.observable();
        this.showPermanentMailingAddress = ko.observable(false);
        this.DoNotContact = ko.observable(false);
        this.EnableDoNotContactFlag = ko.observable(false);
        this.HideCountryData = ko.observable(false);
        this.SummaryContactTemplate = ko.observable('');
        this.MailingAddressText = ko.observable('MailingAddress');
        this.EducationAdviserInfo = ko.observable('');
        this.CountriesUpdated = ko.observable('');
        this.HidePrimaryPhoneNumber = ko.observable(false);
        this.HideAddress =  ko.observable(false);
        /***  PROPERTIES ***/

        sm.portal.vm.custom.setCustomLocalizeKey(self);

        /***  SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("BasicContactContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /***  SECTION PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.FullNumber = ko.computed(function () {
            var number = this.PrimaryPhoneNumber();
            if (!sm.portal.utility.isNullOrEmpty(this.PrimaryPhoneExtension())) {
                number += ' x' + this.PrimaryPhoneExtension();
            }
            return number;
        }, this);

        sm.portal.vm.custom.callCustomization('UpdatedBasicContactProps', self);

        this.AnythingPopulated = ko.computed(function () {
            return true;    // required section
        }, this);
        /***  COMPUTED PROPERTIES ***/
        /**
         * Returns the option ID of the 'default' selectable option
         *
         * @return int
         */
        this.getDefaultAddressFormatId = function (control) {

            var tpls = control.AvailableTemplates();
            var defaultId = 1;

            // no selectable templates?
            if (sm.portal.utility.isNullOrEmpty(tpls)) {
                // default to first item
                return defaultId;
            }
            // iterate items...
            $.each(tpls, function (k, tpl) {
                // found a detault option?
                if (tpl.DefaultSiteTemplate() == true) {
                    defaultId = tpl.ID();
                    return;
                }
              
            });

            return defaultId;
        };
        this.Display = function () {
            self.PrimaryMailingAddress().initAddressLookup();
            self.PermanentMailingAddress().initAddressLookup();
        };
        /*** SECTION METHODS ***/
        this.Initialize = function () {

        };
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("BasicContact", container.Payload.Config);
            }
            self.PrimaryMailingAddress(new sm.portal.vm.MailingAddressViewModel());
            self.PrimaryMailingAddress().LoadModel(container);

            self.EnableDoNotContactFlag(container.Payload.EnableDoNotContactFlag);
            self.DoNotContact(container.Payload.DoNotContact);
            var data = {
                self: self,
                container: container
            }
            sm.portal.vm.custom.callCustomization('UpdateLoadModelBasicContact', data)

            // Transfer the System-Country, Country-List, System-Country-GDistricts to the other View Models that need it. (Demographic)
            viewModel.LoadChildData('Demographic', 'Countries', self.PrimaryMailingAddress().Countries());
            viewModel.LoadChildData('Demographic', 'States', self.PrimaryMailingAddress().GoverningDistrict());

            // TODO: The SystemCountry isn't loading as a MailingAddress model, so we're using a straight JS mapping - needs to change, too fragile.
            if (!sm.portal.utility.isNullOrEmpty(self.PrimaryMailingAddress()) && !sm.portal.utility.isNullOrEmpty(self.PrimaryMailingAddress().SystemCountry()) && !sm.portal.utility.isNullOrEmpty(self.PrimaryMailingAddress().SystemCountry().ID())) {
                viewModel.LoadChildData('Demographic', 'SystemCountryID', self.PrimaryMailingAddress().SystemCountry().ID());
            }

            // Transfer the Mailing Address logic to the other View Models (Payment)
            viewModel.LoadChildData('Payment', 'BillingAddress().Countries', self.PrimaryMailingAddress().Countries());
            viewModel.LoadChildData('Payment', 'BillingAddress().GoverningDistrict', self.PrimaryMailingAddress().GoverningDistrict());
            viewModel.LoadChildData('Payment', 'BillingAddress().StreetSuffix', self.PrimaryMailingAddress().StreetSuffix());
            viewModel.LoadChildData('Payment', 'BillingAddress().Associations', self.PrimaryMailingAddress().Associations());
            viewModel.LoadChildData('Payment', 'BillingAddress().SystemCountry', self.PrimaryMailingAddress().SystemCountry());
            viewModel.LoadChildData('Payment', 'BillingAddress().AllCountryTemplates', self.PrimaryMailingAddress().AllCountryTemplates());

            if (container.Payload.BasicContactPrep != null) {
                self.PrimaryPhoneNumberGID(container.Payload.BasicContactPrep.PrimaryPhoneNumberGID);

                self.PrimaryMailingAddress().AddressGID(container.Payload.BasicContactPrep.PrimaryAddressGID);
                viewModel.LoadChildData('Payment', 'BillingAddress().AddressGID', container.Payload.BasicContactPrep.BillingAddressGID);
                var customData = {
                    self: self,
                    container: container
                }
                sm.portal.vm.custom.callCustomization('UpdateBasicContactPrep', customData);
            }

            if (container.Payload.BasicContact != null) {
                // Load Model with Existing Data
                self.PrimaryPhoneNumberID(container.Payload.BasicContact.PrimaryPhoneNumberID);
                self.PrimaryPhoneNumberGID(container.Payload.BasicContact.PrimaryPhoneNumberGID);
                self.PrimaryPhoneNumber(container.Payload.BasicContact.PrimaryPhoneNumber);
                self.PrimaryPhoneExtension(container.Payload.BasicContact.PrimaryPhoneExtension);
                self.PrimaryPhoneCountryPrefixCode(container.Payload.BasicContact.PrimaryPhoneCountryPrefixCode);
                self.PrimaryPhoneAreaCityCode(container.Payload.BasicContact.PrimaryPhoneAreaCityCode);
                var customParams = {
                    self: self,
                    container: container
                }
                sm.portal.vm.custom.callCustomization('UpdatePermanentMailingAdress', customParams);

                if (!sm.portal.utility.isNullOrEmpty(container.Payload.BasicContact.PrimaryMailingAddress)) {
                    self.PrimaryMailingAddress().LoadAddressModel(container.Payload.BasicContact.PrimaryMailingAddress);
                    self.PrimaryMailingAddress().SelectedCountryID(container.Payload.BasicContact.PrimaryMailingAddress.CountryID);
                    self.PrimaryMailingAddress().SelectedTemplateID(container.Payload.BasicContact.PrimaryMailingAddress.MailingAddressTemplateID);
                    var paraCountrytemplate = {
                        self: self,
                        container: container
                    }
                    sm.portal.vm.custom.callCustomization('UpdateSelectCountryTemplate', paraCountrytemplate);
                }
                else {
                    self.UpdateAddressCountry();
                }
            } else {
                sm.portal.vm.custom.callCustomization('UpdateSet', self)

                self.UpdateAddressCountry();
            }
            var params = {
                self: self,
                container: container    
            }

            sm.portal.vm.custom.callCustomization('LoadModelPortalUpdate', params)

            self.DataLoading(false);
            self.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[ContactVM] Data Loaded'); }

            if (typeof sm.portal.vm.eubasicContact !== 'undefined' && euFeatureEnabled) {
                sm.portal.vm.eubasicContact.LoadModel(self, container);
            }
            if (typeof sm.portal.vm.ukbasicContact !== 'undefined' && ukFeatureEnabled) {
                sm.portal.vm.ukbasicContact.LoadModel(self, container);
            }
            sm.portal.vm.custom.setCustomLocalizeKey(self);
        };

        this.UpdateAddressCountry = function () {
            self.PrimaryMailingAddress().SelectedCountryID(self.PrimaryMailingAddress().SystemCountry().ID());
            if (!sm.portal.utility.isNullOrEmpty(self.PrimaryMailingAddress().AvailableTemplates())) {

                if (typeof self.PrimaryMailingAddress().AvailableTemplates()[0].ID === "function") {
                    self.PrimaryMailingAddress().SelectedTemplateID(self.PrimaryMailingAddress().AvailableTemplates()[0].ID());
                } else {
                    self.PrimaryMailingAddress().SelectedTemplateID(self.PrimaryMailingAddress().AvailableTemplates()[0].ID);
                }
            }
        };

        this.selectCountryTemplate = function (fieldset, templateId) {

            // explicitly setting?
            if (templateId) {

                fieldset.SelectedTemplateID(templateId);
                return;
            }

            // has templates?
            if (!sm.portal.utility.isNullOrEmpty(fieldset.AvailableTemplates())) {

                if (typeof fieldset.AvailableTemplates()[0].ID === "function") {

                    fieldset.SelectedTemplateID(fieldset.AvailableTemplates()[0].ID());

                } else {

                    fieldset.SelectedTemplateID(fieldset.AvailableTemplates()[0].ID);
                }
            }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if (blockui) { self.BlockContainer(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=contact&attemptmid={0}', applicationMID);

                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.vm.custom.callCustomization('UpdateGetModelData', data);
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.BlockContainer = function () {
            $("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            $("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };


        this.ProcessAddressOnServer = function(addressModel, callback){
            var data = addressModel.ExtractATO();
            var customDataPos = {
                self: self,
                data: data
            }
            var dataPer = sm.portal.vm.custom.callCustomization('UpdateProcessOnServer', customDataPos);

            var url = _baseApiUri + 'api/studentportal/processaddress';
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data && data.Status == 'success') {
    
                        // Set the HTML and Text Values
                        var encodedAddress = container.Payload.HTMLValue;
                        if (!sm.portal.utility.isNullOrEmpty(encodedAddress)) {
                            addressModel.AddressHtmlValue(encodedAddress.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
                        } else {
                            addressModel.AddressHtmlValue('');
                        }
                        addressModel.AddressTextValue(container.Payload.TEXTValue);
                    }
                    callback && callback(data);
                },
                error: function (jqXHR, exception) {

                    var statusText = jqXHR.statusText;
                    var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                    if (jqXHR != null && jqXHR.responseText != null) {
                        responseMsg = $.parseJSON(jqXHR.responseText).Message;
                    }
                    var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                    self.UnBlockContainer();
                    callback && callback();
                }
            });

            var customData= {
                dataPer: dataPer,
                self: self,
                url : url
            }
            sm.portal.vm.custom.callCustomization('UpdateProcessOnServerCall', customData);
        };

        this.ProcessOnServer = function () {
            // Submit an entered address to the server to construct TEXT and HTML Values
            this.ProcessAddressOnServer(self.PrimaryMailingAddress(), function(){
                // if EU or UK region and permanent address is different from primary address, process the address
                if((sm.portal.utility.isEUFeatureEnabled() || sm.portal.utility.isUKFeatureEnabled()) && 
                 !self.PrimaryMailingAddress().useMailingAddress()){
                    self.ProcessAddressOnServer(self.PermanentMailingAddress());
                }
            });
        };

        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here

            var stdPhone = new smapi.community.PhoneNumberModel({
                ContactID: 0,
                Number: self.PrimaryPhoneNumber(),
                Extension: self.PrimaryPhoneExtension(),
                CountryPrefixCode: self.PrimaryPhoneCountryPrefixCode(),
                AreaCityCode: self.PrimaryPhoneAreaCityCode(),
                EffectiveFromJS: null,
                EffectiveToJS: null,
                AddressTimingTypeID: 0,
                DoNotContact: false,
                NoContactReasonID: 0,
                PhoneCarrierID: 0,
                ID: self.PrimaryPhoneNumberID(),
                GID: self.PrimaryPhoneNumberGID()
            });

            var stdMailingAddress = self.PrimaryMailingAddress().ExtractATO();
            var returnData = {
                self: self,
                stdPhone: stdPhone,
                stdMailingAddress: stdMailingAddress,
            }
            var customReturn= sm.portal.vm.custom.callCustomization('UpdateExtractATOBasicContact', returnData)
            var r = {
                PhoneNumber: stdPhone,
                MailingAddress: stdMailingAddress,
                DoNotContact: self.DoNotContact()
            };
            if (typeof sm.portal.vm.eubasicContact !== 'undefined' && euFeatureEnabled) {
                sm.portal.vm.eubasicContact.ExtractATO(self, r);
            }
            if (typeof sm.portal.vm.ukbasicContact !== 'undefined' && ukFeatureEnabled) {
                sm.portal.vm.ukbasicContact.ExtractATO(self, r);
            }
            if(sm.portal.utility.isNullOrEmpty(customReturn)){
                return r;
            }
            else{
                return customReturn;
            }

        };
        /*** SECTION METHODS ***/

        sm.portal.vm.custom.callCustomization('OverrideBasicContactValidation',self);
        /*** VALIDATION METHODS ***/
        this.PrimaryPhoneNumber.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_ItsNotAValidPhoneNumber)
            },
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            },
            minLength: {
                params: 6,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_ItsNotAValidPhoneNumber)
            }
        });
        this.PrimaryPhoneExtension.extend({
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.PrimaryPhoneCountryPrefixCode.extend({
            maxLength: {
                params: 3,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '3')
            }
        });
        this.PrimaryPhoneAreaCityCode.extend({
            maxLength: {
                params: 5,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '5')
            }
        });

        this.ModelErrors = ko.validation.group(this);
        this.IsVMValid = function () {
            var validFlag = sm.portal.vm.custom.callCustomization('UpdateModalErrors', self);
            if (!sm.portal.utility.isNullOrEmpty(validFlag)){
                return validFlag
            }
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            var isCompletedCustom = sm.portal.vm.custom.callCustomization('UpdateCompleted', self);
            if(!sm.portal.utility.isNullOrEmpty(isCompletedCustom)){
                if(isCompletedCustom==false){
                    isCompleted = false;
                }
            }
            else{
                    if (!self.PrimaryMailingAddress().IsVMValid()) isCompleted = false;
                    if (typeof sm.portal.vm.eubasicContact !== 'undefined' && euFeatureEnabled && !sm.portal.vm.eubasicContact.Completed(self)) isCompleted = false;
                    if (typeof sm.portal.vm.ukbasicContact !== 'undefined' && ukFeatureEnabled && !sm.portal.vm.ukbasicContact.Completed(self)) isCompleted = false;
                }

            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/

        var self = this;
        return self;
    }

    $.extend(true, sm.portal.vm, {
        BasicContactViewModel: BasicContactViewModel,
    });

})(jQuery);